@if (text) {
  <span
    [matTooltip]="text"
    matTooltipPosition="above"
    matTooltipClass="equivalent-competences-tooltip"
  >
    @if (icon) {
      <mat-icon>{{ icon }}</mat-icon>
    } @else {
      *
    }
  </span>
}
